/* ==========================================================================
   Gild & Ink — Collection (piece-type) page filtering.
   Client-side only, over every rendered card (the handoff rules out
   pagination). Piece-type itself is not a JS filter — it's which collection
   this page is (the tabs are real links) — this only narrows by style,
   colour, bestseller/new and free-text search, all combined with AND.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-gi-filter]');
  var grid = document.querySelector('[data-gi-grid]');
  if (!root || !grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-gi-card]'));
  var empty = document.querySelector('[data-gi-empty]');
  var showingCount = document.querySelector('[data-gi-showing-count]');
  var filterCount = document.querySelector('[data-gi-count]');
  var clearBtn = document.querySelector('[data-gi-clear]');
  var searchInput = document.querySelector('[data-gi-search]');
  var styleWrap = document.querySelector('[data-gi-style]');
  var colourWrap = document.querySelector('[data-gi-colour]');
  var flagsWrap = document.querySelector('[data-gi-flags]');

  var state = { style: '', colour: '', flag: '', query: '' };

  function normalise(s) { return (s || '').toLowerCase().trim(); }

  function apply() {
    var shown = 0;
    var q = normalise(state.query);
    cards.forEach(function (card) {
      var match = true;
      if (state.style && card.getAttribute('data-style') !== state.style) match = false;
      if (match && state.colour && card.getAttribute('data-colour') !== state.colour) match = false;
      if (match && state.flag && card.getAttribute('data-flags') !== state.flag) match = false;
      if (match && q && normalise(card.getAttribute('data-search')).indexOf(q) === -1) match = false;
      card.hidden = !match;
      if (match) {
        shown++;
        card.style.animation = 'none';
        // eslint-disable-next-line no-unused-expressions
        card.offsetHeight;
        card.style.animation = '';
      }
    });

    if (empty) empty.hidden = shown !== 0;
    if (showingCount) showingCount.textContent = shown;
    if (filterCount) filterCount.textContent = shown + (shown === 1 ? ' piece' : ' pieces');

    // Before the day / On the day groups (All pieces view only) — hide a
    // group's heading entirely when nothing in it currently matches.
    document.querySelectorAll('[data-gi-group]').forEach(function (group) {
      var visible = group.querySelectorAll('[data-gi-card]:not([hidden])').length;
      group.hidden = visible === 0;
    });

    var anyActive = !!(state.style || state.colour || state.flag || state.query);
    if (clearBtn) clearBtn.classList.toggle('is-active', anyActive);
  }

  if (styleWrap) {
    styleWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-value]');
      if (!btn) return;
      state.style = btn.getAttribute('data-value');
      styleWrap.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      apply();
    });
  }

  if (colourWrap) {
    colourWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-value]');
      if (!btn) return;
      var value = btn.getAttribute('data-value');
      state.colour = state.colour === value ? '' : value;
      colourWrap.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-value') === state.colour && state.colour !== '');
      });
      apply();
    });
  }

  if (flagsWrap) {
    flagsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-value]');
      if (!btn) return;
      var value = btn.getAttribute('data-value');
      state.flag = state.flag === value ? '' : value;
      flagsWrap.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-value') === state.flag && state.flag !== '');
      });
      apply();
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      state.query = searchInput.value;
      apply();
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      state = { style: '', colour: '', flag: '', query: '' };
      if (searchInput) searchInput.value = '';
      root.querySelectorAll('.gi-chip, .gi-swatch').forEach(function (b) { b.classList.remove('is-active'); });
      if (styleWrap) styleWrap.querySelector('button[data-value=""]').classList.add('is-active');
      apply();
    });
  }

  apply();
})();
